import { z } from "zod";

import { ModelConfigBaseShape } from "../../../../schemas/ModelConfig/model-config.schema";

/**
 * CreateAgentBodySchema
 *
 * Body for POST /api/agents.
 *
 * Naming follows AgentDetailSchema convention (snake_case for Prisma @map fields).
 */
export const CreateAgentBodySchema = z.object({
  first_name: z.string().min(1, "First name is required"),
  last_name: z.string().min(1, "Last name is required"),
  role: z.string().min(1, "Role is required"),
  /**
   * When true (default), initializes the agent with an empty TipTap promptJson document.
   * Set to false to use the legacy plain-text prompt format.
   */
  usePromptJson: z.boolean().optional(),
  /** Legacy AgentModel enum value (e.g. "DEFAULT", "GPT_4_TURBO"). */
  model: z.string().optional(),
  /** Modern model configuration — overrides model/modelName/modelProvider when set. */
  modelConfig: z.object(ModelConfigBaseShape).optional(),
  /** Model name (e.g. "gpt-4o", "claude-sonnet-4-6"). Used when modelConfig is not provided. */
  modelName: z.string().max(255).optional(),
  /** Model provider (e.g. "OPEN_AI", "ANTHROPIC"). Used when modelConfig is not provided. */
  modelProvider: z.string().max(255).optional()
});

export type CreateAgentBody = z.infer<typeof CreateAgentBodySchema>;
